import React from "react";
import './infos.scss';

import photo from './assets/novembro-blue.png';

export default function Infos(){
  return(
    <>
      <section id="background-info">
        <div className = "container d-flex">
          <figure className="box"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0" >
            <img src={photo} width = "70" alt="janeiro branco - Séculos Engenharia" />
          </figure>
          <div className="box"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0" >
            <h2>
              <b className="negrito">novembro</b>
            </h2>
            <div className="box-2">
              <h3 className="orang"><b>azul</b></h3>
              {/* <h3 className="purpple"><b>roxo</b></h3> */}
              <p className="text">
                O cuidado é o passo mais
                <b> importante </b>
                para uma vida mais longa.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}